import React from 'react';
import {MantineProvider} from '@mantine/core';
import '@mantine/notifications/styles.css';
import {Notifications} from "@mantine/notifications";


import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <MantineProvider theme={{
            fontFamily: 'IRANSansXFaNum, sans-serif',
            fontFamilyMonospace: 'IRANSansXFaNum, Courier, monospace',
            headings: {fontFamily: 'IRANSansXFaNum, sans-serif'},
        }}>
            <Notifications position="top-right" style={{minHeight: '50px' ,}}/>
            <App/>
        </MantineProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
